import {
  CameraIntegration,
  contactSupportMessage,
  epochTimeOfSelectedEvent,
} from './base';
import { post } from '../securityService';

export class Wachter extends CameraIntegration {
  constructor(...args) {
    super(...args);
    this.cameraProviderName = 'Wachter';
  }

  checkForCredentials() {
    // authToken = accessToken
    const accessToken = this.camera?.authToken;
    // if there is no camera list, we force the user to re log in
    this.isAuthenticated =
      !!accessToken &&
      accessToken !== 'refresh_token_invalid' &&
      accessToken !== 'refresh_token_not_available' &&
      this.camera.cameraList?.length > 0;
    this.camera.accessToken = accessToken;
  }

  async submitCredentials(username, password) {
    const { location } = this.camera;

    const loginCredentials = {
      un: username,
      pw: password,
    };

    const response = await post(
      `security/wachter_submit_creds/${location}`,
      loginCredentials,
      { orgId: this.orgId },
    ).catch((err) => {
      console.error(err);
      throw Error(
        'We were unable to submit your login information to Wachter at this time. Please try again later. If this error is reoccurring, please contact support for assistance. ',
      );
    });

    this.camera.authToken = response.authToken;
    this.camera.cameraList = response.cameraList;
    this.isAuthenticated = true;
  }

  async fetchThumbnails() {
    const thumbnails = [];

    const {
      cameraList,
      config: { orchidId },
      authToken,
    } = this.camera;

    cameraList.forEach((camera) => {
      const url = `https://mcdonalds.ipconfigure.com/service/orchids/${orchidId}/cameras/${camera.id}/preview?jwt=${authToken}`;
      thumbnails.push({ id: camera.id, src: url, title: camera.name });
    });

    if (thumbnails.length === 0)
      throw Error(
        `We were unable to find the camera thumbnails associated with your Wachter account. ${contactSupportMessage}`,
      );
    return thumbnails;
  }

  async fetchVideo(cameraId) {
    const nowPlaying = {
      offsetSeconds: 0,
      displayTime: this.event.time,
    };

    const {
      timezone,
      authToken,
      config: { orchidId },
      cameraList,
    } = this.camera;

    if (!authToken) {
      console.error('Missing wachter authToken');
      throw Error(
        `We were unable to authenticate your Wachter account. ${contactSupportMessage}`,
      );
    }
    if (!orchidId) {
      console.error('Missing wachter orchidId');
      throw Error(
        `We were unable to find the cameras associated with your Wachter account. ${contactSupportMessage}`,
      );
    }

    if (cameraId)
      nowPlaying.camera = cameraList.find((camera) => camera.id === cameraId);
    else [nowPlaying.camera] = cameraList;

    if (Object.keys(nowPlaying.camera).length === 0) {
      console.error(
        'Could not find the camera associated with the provided camera id in the camera list',
        { cameraId, cameraList },
      );
      throw Error(
        `We were unable to find the video for this camera because this camera was not found to be associated with your Wachter account. ${contactSupportMessage}`,
      );
    }

    nowPlaying.event = this.event;
    nowPlaying.description = `${nowPlaying.camera.name} from ${nowPlaying.displayTime}`;
    nowPlaying.cameraId = nowPlaying.camera.id;
    nowPlaying.authToken = authToken;

    if (!nowPlaying.cameraId) {
      console.error(
        'Could not find the camera id from the selected camera needed to update the video player',
        { cameraId },
      );
      throw Error(
        'We were unable to identify the selected camera in order to display the associated video. Please contact support for assistance.',
      );
    }

    const epochMilliSeconds = epochTimeOfSelectedEvent({
      format: 'milli',
      time: nowPlaying.displayTime,
      timezone,
    });

    const params = {
      'single-player-orchid': orchidId,
      'single-player': nowPlaying.camera.streamId,
      'start-time': epochMilliSeconds,
      'disable-webrtc': 1,
    };
    const url = `https://mcdonalds.ipconfigure.com/?${new URLSearchParams(
      params,
    ).toString()}`;

    nowPlaying.video = {
      type: 'iframe',
      src: url,
      vendor: 'wachter',
    };

    return nowPlaying;
  }
}
